import React from 'react';

import Modal from '../Modal';
import Drawer from '../Drawer';
import useMediaQuery from '@src/hooks/useMediaQuery';
import { breakpoints } from '@src/common/breakpoints';

type ResponsiveModalProps = {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  width?: number;
  title?: string;
  showCloseButton?: boolean;
};

export const ResponsiveModal = (props: ResponsiveModalProps) => {
  const { open, onClose, children, width = 600, title, showCloseButton = true } = props;

  const isMobile = useMediaQuery(breakpoints.mobile);

  return (
    <>
      {isMobile ? (
        <Drawer open={open} onClose={onClose} title={title} showCloseButton={showCloseButton}>
          {children}
        </Drawer>
      ) : (
        <Modal open={open} onClose={onClose} width={width} title={title} showCloseButton={showCloseButton}>
          {children}
        </Modal>
      )}
    </>
  );
};

export default ResponsiveModal;
